import yup from "src/validators/yup.Module";
import { yupDataValidator } from "src/validators/yupMomentDateTimeValidator";

export type FormType = yup.InferType<typeof InformacoesAdicionaisSchema>;

export const InformacoesAdicionaisSchema = yup.object().shape({
  informacoesComplementaresContribuinte: yup
    .string()
    .nullable()
    .notRequired()
    .transform((value) => (value ? value.trim() : null))
    .test(
      "not-only-spaces",
      "As informações do contribuinte não podem conter apenas espaços em branco.",
      (value) => value === undefined || value === null || value.length > 0
    )
    .max(
      2000,
      "As informações do contribuinte devem ter no máximo 2000 caracteres."
    ),

  informacoesAdicionaisFisco: yup
    .string()
    .nullable()
    .notRequired()
    .transform((value) => (value ? value.trim() : null))
    .test(
      "not-only-spaces",
      "As informações do contribuinte não podem conter apenas espaços em branco.",
      (value) => value === undefined || value === null || value.length > 0
    )
    .max(
      2000,
      "As informações do contribuinte devem ter no máximo 2000 caracteres."
    ),
  emissaoDataHora: yupDataValidator("Data de emissão", "DD/MM/YYYY HH:mm:ss"),
  saidaEntradaDataHora: yupDataValidator(
    "Data hora entrada/saída",
    "DD/MM/YYYY HH:mm:ss",
    false
  ),
  numeroNF: yup
    .number()
    .nullable()
    .notRequired()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue === null || isNaN(value)
        ? null
        : value
    )
    .min(0, "O número da NF-e deve ser maior ou igual a zero"),
});
